import React, { useContext, useEffect, useState } from 'react'
import { ConfigContext } from 'Utils/Contexts';
import ButtonSendMessage from './ButtonSendMessage';
import styles from "./StartConversation.module.scss";
import { AvatarComponent } from 'avatar-initials';

export default function StartConversation(props) {

    const configContext = useContext(ConfigContext);
    const [thisConfig, setthisConfig] = useState(null);

    useEffect(() => {
        setthisConfig(configContext.containersMetaData.containers.startConversation);
    }, [configContext])

    

    return (
        <div className={styles.container}>
            <div className={styles.title}>{thisConfig?.title}</div>
            <div className="">{thisConfig?.message}</div>
{/*            <div className={styles.team}>*/}
{/*                <div className={`${styles["container-avatars"]} config--startConversation-avatars`}>*/}
{/*                {*/}
{/*          (thisConfig?.avatars.metaData[0].fullName !== "") ?*/}
{/*          (<div className={*/}
{/*            `${styles.avatar} ${styles["avatar-1"]} avatar`*/}
{/*          }>*/}
{/*            <AvatarComponent*/}
{/*          classes="rounded-full"*/}
{/*          useGravatar={false}*/}
{/*          size={44}*/}
          
{/*          color="#FFFFFF"*/}
{/*          background="#A13808"*/}
{/*          fontSize={16}*/}
{/*          fontWeight={400}*/}
{/*          offsetY={24}*/}
{/*          initials={`${thisConfig?.avatars.metaData[0].fullName[0]}`}*/}
{/*        />*/}
{/*            </div>) :*/}
{/*          (*/}
{/*            <></>*/}
{/*          )*/}
{/*          }*/}


{/*      {*/}
{/*      (thisConfig?.avatars.metaData[1].fullName !== "") ?*/}
{/*          (<div className={*/}
{/*            `${styles.avatar} ${styles["avatar-2"]} avatar`*/}
{/*          }>*/}
{/*            <AvatarComponent*/}
{/*          classes="rounded-full"*/}
{/*          useGravatar={false}*/}
{/*          size={44}*/}
          
{/*          color="#FFFFFF"*/}
{/*          background="#A13808"*/}
{/*          fontSize={16}*/}
{/*          fontWeight={400}*/}
{/*          offsetY={24}*/}
{/*          initials={`${thisConfig?.avatars.metaData[1].fullName[0]}`}*/}
{/*        />*/}
{/*            </div>) :*/}
{/*          (*/}
{/*            <></>*/}
{/*          )*/}
{/*          }*/}

{/*{*/}
{/*      (thisConfig?.avatars.metaData[2].fullName !== "") ?*/}
{/*          (<div className={*/}
{/*            `${styles.avatar} ${styles["avatar-3"]} avatar`*/}
{/*          }>*/}
{/*            <AvatarComponent*/}
{/*          classes="rounded-full"*/}
{/*          useGravatar={false}*/}
{/*          size={44}*/}
          
{/*          color="#FFFFFF"*/}
{/*          background="#A13808 "*/}
{/*          fontSize={16}*/}
{/*          fontWeight={400}*/}
{/*          offsetY={24}*/}
{/*          initials={`${thisConfig?.avatars.metaData[2].fullName[0]}`}*/}
{/*        />*/}
{/*            </div>) :*/}
{/*          (*/}
{/*            <></>*/}
{/*          )*/}
{/*          }*/}
{/*                </div>*/}
{/*                <div className="message">*/}
{/*                    <div className={styles["text-small-opacity"]}>Our usual reply time</div>*/}
{/*                    <div className={styles["flex-notify"]}>*/}
{/*                        <span><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" ><path fillRule="evenodd" d="M12.5 7c0 3.0376-2.4624 5.5-5.5 5.5-3.03757 0-5.5-2.4624-5.5-5.5 0-3.03757 2.46243-5.5 5.5-5.5 3.0376 0 5.5 2.46243 5.5 5.5zM14 7c0 3.866-3.134 7-7 7-3.86599 0-7-3.134-7-7 0-3.86599 3.13401-7 7-7 3.866 0 7 3.13401 7 7zM6.27844 3.48219v3.78093l.00105.00104c.00305.07805.03658.1518.09341.20546l.07452.0566L9.6706 9.69708l.15009.03773h.05667c.09341-.01886.14904-.07442.20574-.13102l.4125-.65514c.0355-.04926.0552-.10809.0566-.16876 0-.09329-.0566-.14885-.1501-.20545L7.62817 6.68345V3.48219c0-.14989-.1312-.29979-.30017-.29979h-.74938c-.16898 0-.30018.1499-.30018.29979z" clipRule="evenodd" fill={thisConfig?.button.fontColor}></path></svg></span>*/}
{/*                        <span>A few minutes</span>*/}
{/*                    </div>*/}
{/*                </div>*/}
{/*            </div>*/}
            {props.button?<ButtonSendMessage></ButtonSendMessage>:""}
            
        </div>
    )
}
